import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import pathsManifest from '../../../pathsManifest';
import './style.scss';

class Dashboard extends React.Component {
  static propTypes = {
    brand: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      payments: false,
      applications: false,
    };
  }

  render() {
    const { brand } = this.props;

    return (
      <Container fluid fluidMobile className="inset-lg">
        <Text type="h1" className="stacked-lg">
          Renter Hub Dashboard
        </Text>

        {brand === 'zillow' && (
          <>
            <div className="stacked-md">
              <Link href={pathsManifest.paymentsPage}>View rental payments</Link>
            </div>
            <div className="stacked-md">
              <Link href={pathsManifest.applicationsPage}>View rental applications</Link>
            </div>
          </>
        )}

        <div className="stacked-md">
          <Link href={pathsManifest.inboxPage}>View rental messages</Link>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps)(Dashboard);
